export enum ActivityType {
  ADVENTURE = 'ADVENTURE',

  NIGHT = 'NIGHT',

  WELLNESS = 'WELLNESS',

  KIDS = 'KIDS',

  TOURING = 'TOURING',

  ADRENALIN = 'ADRENALIN',

  TRANSFERS = 'TRANSFERS',

  CULTURAL = 'CULTURAL',

  DINING = 'DINING',

  AQUATIC = 'AQUATIC',
}
